/**
 * パスワード条件の箇条書き。入力中のパスワードが満たした条件にチェックを付ける。
 */
import { PASSWORD_RULES } from './passwordPolicy';

interface PasswordRequirementsProps {
  password: string;
}

export function PasswordRequirements({ password }: PasswordRequirementsProps): React.JSX.Element {
  return (
    <ul className="password-requirements" data-testid="password-requirements">
      {PASSWORD_RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li
            key={rule.id}
            data-testid={`password-rule-${rule.id}`}
            data-satisfied={ok ? 'true' : 'false'}
            className={ok ? 'satisfied' : undefined}
          >
            <span aria-hidden="true">{ok ? '✓' : '○'}</span> {rule.label}
            <span className="visually-hidden">{ok ? ' (条件を満たしています)' : ' (未達成)'}</span>
          </li>
        );
      })}
    </ul>
  );
}
